<template>
  <select v-model="selected">
    <option></option>
    <option
      v-for="campus of campuses"
      :key="campus.code"
      :value="campus"
    >
      {{ campus.name }}
    </option>
  </select>
</template>

<script lang="ts">
import _ from 'lodash'
import { Campus, University } from '@/store/master/types'
import { RootState } from '@/store/types'
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator'

@Component
export default class SelectCampusInput extends Vue {
  @Prop() value?: Campus

  @Prop() belongsToUniversity?: University

  created() {
    this.$store.dispatch('fetchMasterCampuses')
  }

  private get selected(): Campus|undefined {
    return this.value
  }

  private set selected(campus: Campus|undefined) {
    this.$emit('input', campus)
  }

  private get campuses(): Campus[] {
    const { campuses } = (this.$store.state as RootState).master
    if (this.belongsToUniversity) {
      return _.filter(campuses, { universityCode: this.belongsToUniversity.code })
    }
    return campuses
  }

  @Watch('belongsToUniversity')
  private changedUniversity() {
    this.selected = undefined
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
